import { render, staticRenderFns } from "./PRow.vue?vue&type=template&id=527cadea&scoped=true&"
import script from "./PRow.vue?vue&type=script&lang=ts&"
export * from "./PRow.vue?vue&type=script&lang=ts&"
import style0 from "./PRow.vue?vue&type=style&index=0&id=527cadea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527cadea",
  null
  
)

export default component.exports